<h1 mat-dialog-title class="header">{{ 'DELETE-FIELD-DIALOG.DELETE-TITLE' | translate }}</h1>
<div mat-dialog-content>
    <p class="description">{{ 'DELETE-FIELD-DIALOG.DELETE-FIELD' | translate }}</p>
</div>
<div mat-dialog-actions>
    <button class="delete-field-option-btn" mat-flat-button  (click)="deleteField()">{{ 'DELETE-ALL-PINS-DIALOG.YES' | translate }}</button>
    <button class="delete-field-option-btn" mat-flat-button  (click)="cancel()">{{ 'DELETE-ALL-PINS-DIALOG.NO' | translate }}</button>
</div>
